module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e6283fbede8ac619c52897552aec251e.png";